if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.hasLoaded = false;
      }

      connectedCallback() {
        if (this.hasLoaded || !this.dataset.url) return;
        if (this.querySelector('.product-card')) { this.hasLoaded = true; return; }
        this.style.display = 'block';
        this.reservedHeight ??= this.style.minHeight;
        this.style.minHeight ||= this.classList.contains('complementary-products') ? '120px' : 'min(32rem, 70vh)';
        if (!('IntersectionObserver' in window)) { this.init(); return; }
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.init();
          }
        }, { rootMargin: `${Math.max(1, window.innerHeight)}px 0px` });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        window.clearTimeout(this.retryTimer);
        this.loading = false;
      }

      init() {
        if (this.hasLoaded || this.loading || !this.isConnected || !this.dataset.url) return;
        this.loading = true;
        const controller = this.controller = new AbortController();
        this.setAttribute('aria-busy', 'true');

        fetch(this.dataset.url, { signal: controller.signal })
          .then((response) => { if (!response.ok) throw new Error('recommendations_unavailable'); return response.text(); })
          .then((responseText) => {
            if (!this.isConnected || this.controller !== controller) return;
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) throw new Error('recommendations_invalid');

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (!recommendations) throw new Error('recommendations_invalid');
            this.hasLoaded = true;

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block')?.remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch(() => {
            if (controller.signal.aborted || !this.isConnected || this.controller !== controller) return;
            // One retry for a transient failure, never an idle request loop.
            if (!this.retried) {
              this.retried = true;
              this.retryTimer = window.setTimeout(() => { this.retryTimer = null; this.init(); }, 1200);
            }
          })
          .finally(() => {
            if (this.controller !== controller) return;
            this.loading = false;
            this.removeAttribute('aria-busy');
            if (this.hasLoaded || this.retried && !this.retryTimer) this.style.minHeight = this.reservedHeight || '';
          });
      }
    }
  );
}
